import {defineStore} from "pinia";
import {ref} from "vue";

export const useLoadingSpinnerStore = defineStore('loadingSpinner', () => {
    const loading = ref<Map<string, boolean>>(new Map<string, boolean>())
    function startLoading(identify: string){
        loading.value.set(identify, true);
    }
    function stopLoading(identify: string){
        loading.value.delete(identify);
   }
   function stopAllLoading(){
        loading.value.clear();
   }
    return {startLoading, stopLoading, stopAllLoading, loading}
})
